//import { useCallback, useEffect, useRef, useState } from 'react'

//import { useDispatch } from '../redux/store'
//import { Response, Request } from '../schemas'
//import Cookies from 'js-cookie'

//import { eventCentral } from 'redux/action-creators/event-central'
//import addMessageChunks from 'utils/messageSequence'

//import { generateID } from 'utils/generateMessageID'
//import { useWsContext } from './useWsContext'
//import { REQUEST_MESSAGE_TYPES } from 'schemas/request'
//import { setConnectivity } from 'redux/slices/socket-data'
//import { useSnackbar } from 'notistack'
//export interface useSocketConnectPropsInterface {
//  serviceURl: string
//}

//export interface useSocketConnectInterface {
//  somethingWentWrong: boolean
//  timeToCloseConnection: boolean
//  onSocketOpen: () => void
//  connectSocket: () => void
//  onSocketSend: () => Promise<unknown>
//  onSocketClosed: () => Promise<boolean>
//  reconnectSocket: () => void
//  socket: WebSocket
//  checkWebSocketStatus: () => string
//}

//export default function useSocketConnection() {
//  const dispatch = useDispatch()
//  const [somethingHappened, setSomethingHappened] = useState(false)
//  const [isAuthenticated, setIsAuthenticated] = useState(false);
//  const [authSuccessCallback, setAuthSuccessCallback] = useState(() => () => { });
//  const [timeToCloseConnection, setTimeToCloseConnection] = useState(false)
//  const socket = useRef<WebSocket | null>()
//  let decodedValues = {}
//  const ws = useWsContext()
//  const lastPingTime = useRef(Date.now())
//  const { enqueueSnackbar } = useSnackbar()
//  useEffect(() => {
//    if (somethingHappened) {
//      dispatch(setConnectivity(true))
//    } else if (!somethingHappened) {
//      dispatch(setConnectivity(false))
//    }
//  }, [somethingHappened, dispatch])

//  useEffect(() => {
//    if (ws.webSocket) {
//      socket.current = ws.webSocket
//      socket.current.onopen = () => onSocketOpen()
//      socket.current.onclose = () => onSocketClosed()
//      socket.current.onmessage = ({ data }) => onSocketMessage(data)
//    }
//    return () => {
//      if (timeToCloseConnection && socket.current) {
//        socket.current.onclose = null
//        socket.current.onopen = null
//        socket.current.onmessage = null
//        socket.current.onerror = null
//      }
//    }
//  }, [ws.webSocket])

//  const checkWebSocketStatus = () => {
//    if (!ws.webSocket) return 'Not initialized'
//    switch (ws.webSocket?.readyState) {
//      case WebSocket.CONNECTING:
//        return 'Connecting...'
//      case WebSocket.OPEN:
//        return 'Connected'
//      case WebSocket.CLOSING:
//        return 'Closing...'
//      case WebSocket.CLOSED:
//        return 'Disconnected'
//      default:
//        return 'Unknown State'
//    }
//  }

//  const onSocketClosed = () => {
//    const fetchedValue = Cookies.get('token')
//    if (
//      ws.webSocket?.readyState === ws.webSocket?.OPEN &&
//      fetchedValue !== null &&
//      fetchedValue !== undefined
//    ) {
//      onSocketSend({
//        messageId: generateID(),
//        messageType: REQUEST_MESSAGE_TYPES.DeAuth,
//        DeAuth: {
//          jwt: fetchedValue
//        }
//      }).then(() => {
//        Cookies.remove('token')
//        setTimeout(() => {
//          console.log('Close: *--------Closing Connection from Hook-------*')
//          ws.webSocket?.close()
//        }, 500)
//      })
//    }
//    setSomethingHappened(true)
//  }
//  function trackPing() {
//    const currentTime = Date.now()
//    const timeSinceLastPing = currentTime - lastPingTime.current

//    // Check if the time since the last ping exceeds 2 minutes (120,000 milliseconds)
//    if (timeSinceLastPing > 120000) {
//      setTimeToCloseConnection(true)
//      handleDisconnect()
//    }
//  }
//  function handleDisconnect() {
//    setSomethingHappened(true)
//  }
//  useEffect(() => {
//    const pingCheckInterval = setInterval(() => {
//      trackPing()
//    }, 5000) // Check every 5 seconds

//    return () => clearInterval(pingCheckInterval)
//  }, [])
//  const onSocketMessage = (data: Response) => {
//    // TODO: data should come as an object
//    const dataObj = JSON.parse(data.toString())
//    lastPingTime.current = Date.now()
//    setSomethingHappened(false)
//    const messageType = dataObj.messageType

//    switch (messageType) {
//      case 'AuthConfirmation':
//        authSuccessCallback()
//        setIsAuthenticated(true)
//        eventCentral(data.toString())

//        break;
//      case 'MessageSegment32KB':
//        decodedValues[dataObj.messageIdReference] = addMessageChunks(
//          dataObj,
//          decodedValues[dataObj.messageIdReference]
//        )
//        if (
//          dataObj[`${messageType}`]?.part === dataObj[`${messageType}`]?.parts &&
//          !!decodedValues
//        ) {
//          eventCentral(decodedValues[dataObj.messageIdReference])
//        }

//        break

//      default:
//        eventCentral(data.toString())

//        break
//    }
//  }

//  const onSocketSend = async (data: Request) =>
//    new Promise((resolve, reject) => {
//      try {
//        waitForSocketConnection(socket, function () {
//          socket.current?.send(JSON.stringify(data))
//        })
//        if (socket?.current?.readyState === WebSocket.CLOSED) {
//          enqueueSnackbar('Websocket Diconnected. Please refresh!!!', { variant: 'error' })
//        }
//        return resolve(true)
//      } catch (error) {
//        console.log('error', error)
//        return reject(false)
//      }
//    })

//  // Function to set the authentication success callback
//  const registerAuthSuccessCallback = useCallback((callback) => {
//    setAuthSuccessCallback(() => callback);
//  }, []);
//  const onSocketOpen = () => {
//    const fetchedValue = Cookies.get('token')
//    //if (value) {
//    if (socket.current?.readyState !== WebSocket.CONNECTING) {
//      const intitateAuth: Request = {
//        messageId: generateID(),
//        messageType: REQUEST_MESSAGE_TYPES.Auth,
//        Auth: {
//          jwt: fetchedValue
//        }
//      }
//      socket.current?.send(JSON.stringify(intitateAuth))
//    }
//  }

//  //This function is used from the useSocketData hook
//  function reconnectSocket() {
//    console.log('-----Reconnecting websocket------')
//    onSocketOpen()
//  }

//  // Make the function wait until the connection is made...
//  function waitForSocketConnection(socket, callback) {
//    setTimeout(function () {
//      if (socket.current?.readyState === 1) {
//        if (callback != null) {
//          callback()
//        }
//      } else {
//        waitForSocketConnection(socket, callback)
//      }
//    }, 500) // wait 5 milisecond for the connection...
//  }

//  const onSocketError = (error) => console.log('websocket error: ', error)

//  return {
//    somethingWentWrong: somethingHappened,
//    timeToCloseConnection: timeToCloseConnection,
//    onSocketOpen,
//    onSocketClosed,
//    onSocketSend,
//    socket,
//    reconnectSocket,
//    onSocketError,
//    checkWebSocketStatus,
//    registerAuthSuccessCallback,
//    isAuthenticated
//  }
//}

import { SocketContext } from "contexts/SocketProvider"
import { useContext } from "react"

export function useSocketConnection() {
  const ctx = useContext(SocketContext)
  if (!ctx) throw new Error('useSocketConnection must be used within a SocketProvider')
  return ctx
}
